import React, { useEffect, useState } from "react";
import ContactsList from "./ContactsList";
import { proxyAPI } from "../proxyAPI";
import MyPagination from "../Common/MyPagination";
import FullScreenLoadingIndicator from "../Common/FullScreenLoadingIndicator";
import { isUserPermitted } from "../helpers/pageProps";

export default function Contacts({
  filters,
  fields,
  useSearchOptions,
  includeContacts,
  ignoreContacts,
  ignoreSets,
  contactSet,
  contactSets,
  strictCriteria,
  doNotUseSets,
  contactButton,
  notDraggable,
  onDrop,
  allContactsButton,
  fullView = true,
  isModal,
  showContactFields,
  setSelectedContacts,
  sendListOptions = undefined,
  setTotal: setTotalRecipients = undefined,
  highlighChannelsIfNotAvailable = undefined,
}) {
  const [contacts, setContacts] = useState([]);
  const contactItems = Array.isArray(contacts) ? contacts : [];
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [resetPagination, setResetPagination] = useState(Date.now());

  const findContacts = async (page = 0, perPage = 10) => {
    if (isUserPermitted("view_contact")) {
      setLoading(true);

      const bodyContent = {
        filters: filters?.map((f) => ({
          ...f,
          ...(f.values ? { values: f.values.filter((v) => v !== "") } : {}),
        })),
        paginate: {
          order: "desc",
          order_by: "created_at",
          page,
          perPage,
        },
        fields: fields || {
          uuids: [],
          cards: true,
          channels: true,
        },
        ...(sendListOptions
          ? { sendListOptions: { ...sendListOptions, ignore: ignoreSets } }
          : {}),
        ...(!sendListOptions && useSearchOptions === true
          ? {
              searchOptions: {
                ignoreContacts: ignoreContacts || [],
                includeContacts: includeContacts || [],
                sets: contactSets || [contactSet?.uuid],
                ignoreSets,
                strictCriteria,
                doNotUseSets,
              },
            }
          : {}),
      };
      const data = await proxyAPI({
        prefix: "contacts/v1",
        method: "POST",
        url: "/find",
        body: bodyContent,
      });
      setTimeout(() => {
        setLoading(false);
        if (data?.pagination) {
          setContacts(data.contacts || []);
          setTotal(data.pagination.total);
          setTotalRecipients?.(data.pagination.total);
        }
      }, 500);
    }
  };

  useEffect(() => {
    if (!filters || filters?.length === 0) {
      return;
    }
    if (
      filters?.some(
        (filter) =>
          !["empty", "not-empty"].includes(filter.operator) &&
          // filter.fields[0] !== "status" &&
          !filter.values?.length
      )
    ) {
      return;
    }
    if (
      filters?.some(
        (filter) => filter.formats.length === 0 && filter.fields.length === 0
      )
    ) {
      return;
    }

    const timeout = setTimeout(() => {
      setResetPagination(Date.now());
    }, 500);

    return () => clearTimeout(timeout);
  }, [filters]);

  useEffect(() => {
    setResetPagination(Date.now());
  }, [
    ignoreContacts,
    includeContacts,
    contactSets,
    contactSet?.uuid,
    ignoreSets,
    sendListOptions,
  ]);

  return (
    <div
      className="h-100 d-flex flex-column"
      onDragOver={(e) => {
        const contactUuid = e.dataTransfer.getData("text/plain");
        if (!contactItems.some((c) => c.uuid === contactUuid)) {
          e.preventDefault();
          e.dataTransfer.dropEffect = "copy";
        }
      }}
      onDrop={(e) => {
        const contactUuid = e.dataTransfer.getData("text/plain");
        onDrop(contactUuid);
      }}
    >
      <FullScreenLoadingIndicator loading={loading} />
      {isUserPermitted("view_contact") ? (
        <div className="">
          <ContactsList
            key={contactItems.map((c) => c.uuid).join(",")}
            contacts={contactItems}
            contactButton={contactButton}
            allContactsButton={allContactsButton?.(contactItems)}
            refreshList={findContacts}
            notDraggable={notDraggable}
            fullView={fullView}
            isModal={isModal}
            showContactFields={showContactFields}
            onSelectContacts={setSelectedContacts}
            highlighChannelsIfNotAvailable={highlighChannelsIfNotAvailable}
          />
        </div>
      ) : (
        <div className="alert alert-warning">
          You do not have permission to view contacts.
        </div>
      )}

      <MyPagination
        total={total}
        key={resetPagination}
        onPaginate={findContacts}
      />
    </div>
  );
}
